module.exports = __webpack_public_path__ + "img/loader.d5ef0ed8.gif";